import { Heading, Text } from 'ui-kit/typography'
import { uiData } from './uiData'
import { IntegrationUXUICard } from './IntegrationUXUICard'
import clsx from 'clsx'
import classes from './IntegrationUXUI.module.scss'

export const IntegrationUXUI = () => {
  return (
    <section className={classes.section}>
      <div className={classes.body}>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Use pre-built UI components or create your own
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Make your own tradeoff between fast development and customization -
          from a single line of code to fully custom UI.
        </Text>
        <ul className={classes.list}>
          {uiData.map((card, index) => {
            return (
              <li
                className={clsx(classes.item, classes[card.type])}
                key={index}
              >
                <IntegrationUXUICard card={card} />
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
